import { CheckCircle, ArrowRight } from "@phosphor-icons/react";
import { Link } from "react-router-dom";
import { Reveal, SectionHeading } from "../Reveal";

const POINTS = [
    "Advanced medical expertise",
    "Specialized healthcare infrastructure",
    "Experienced clinicians",
    "Competitive treatment economics",
    "Growing international healthcare ecosystem",
];

export default function WhyIndia() {
    return (
        <section data-testid="why-india-section" className="py-28 lg:py-36 bg-white">
            <div className="max-w-7xl mx-auto px-6 lg:px-8">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 items-center">
                    <div className="lg:col-span-6">
                        <SectionHeading
                            chapter="05"
                            eyebrow="Why India"
                            title="A global healthcare destination."
                            description="India has emerged as an important destination for international patients seeking specialized and cost-effective healthcare. GoMedVoyage aims to build the technology and patient-navigation infrastructure that makes accessing India's healthcare ecosystem simpler, more transparent and more connected."
                            testid="why-india-heading"
                        />
                        <ul className="mt-10 space-y-4">
                            {POINTS.map((p, i) => (
                                <Reveal key={p} delay={0.06 * i}>
                                    <li className="flex items-center gap-3 text-base font-medium text-slate-700" data-testid={`why-india-point-${i + 1}`}>
                                        <CheckCircle size={22} weight="fill" className="text-brand-green shrink-0" />
                                        {p}
                                    </li>
                                </Reveal>
                            ))}
                        </ul>
                        <Reveal delay={0.35}>
                            <Link
                                data-testid="why-india-cta"
                                to="/about"
                                className="mt-10 inline-flex items-center gap-2 rounded-full bg-brand-blue px-8 py-4 text-sm font-semibold text-white shadow-lg shadow-brand-blue/25 hover:bg-brand-blue-light active:scale-95 transition-[background-color,box-shadow,transform] duration-200"
                            >
                                Explore the GoMedVoyage Vision
                                <ArrowRight size={16} weight="bold" />
                            </Link>
                        </Reveal>
                    </div>
                    <div className="lg:col-span-6">
                        <Reveal delay={0.2}>
                            <div className="relative">
                                <div className="absolute -inset-4 rounded-[2rem] bg-tint-green -rotate-2" aria-hidden="true" />
                                <img
                                    src="https://images.unsplash.com/photo-1587351021821-f871837248c6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBob3NwaXRhbCUyMGFyY2hpdGVjdHVyZXxlbnwwfHx8fDE3ODczMzA5NzN8MA&ixlib=rb-4.1.0&q=85"
                                    alt="Modern hospital architecture in India"
                                    loading="lazy"
                                    className="relative rounded-[1.75rem] w-full h-[420px] lg:h-[520px] object-cover shadow-[0_24px_60px_rgb(10,37,64,0.15)]"
                                    data-testid="why-india-image"
                                />
                                <div className="absolute -bottom-6 -left-6 bg-white rounded-2xl border border-slate-100 shadow-xl px-6 py-4">
                                    <p className="text-xs uppercase tracking-[0.2em] font-bold text-brand-green">India</p>
                                    <p className="mt-1 font-heading text-lg font-semibold text-brand-blue">Where expertise meets access</p>
                                </div>
                            </div>
                        </Reveal>
                    </div>
                </div>
            </div>
        </section>
    );
}
